import React from "react";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../common/PageTitle";
import Editor from "./Editor";
import SidebarActions from "./SidebarActions";
import SidebarCategories from "./SidebarCategories";
import AlertBox from '../AlertBox';

const SMS = () => (
<div>
<AlertBox />
  <Container fluid className="main-content-container px-4 pb-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle sm="4" title="Email" subtitle="Send" className="text-sm-left" />
    </Row>

    <Row>
      {/* Editor */}
      <Col lg="9" md="12">
      	<Editor />
      </Col>

      {/* Sidebar Widgets */}
      <Col lg="3" md="12">
        <SidebarCategories />
        <SidebarActions />
      </Col>
    </Row>
  </Container>
</div>
);

export default SMS;
